import { normalizeHomeData } from '@/api/ucenter';

export function parseLottoUpdateMessage(message) {
    if (!message || message.action !== 'LOTTO_UPDATE') {
        return null;
    }

    const payload = message.data || {};

    return normalizeHomeData({
        lastLotto: payload.lastLotto || payload.last_lotto,
        currentLotto: payload.currentLotto || payload.current_lotto,
        unveilTime: payload.unveilTime ?? payload.unveil_time,
        unveil_time: payload.unveil_time,
        countdown: payload.countdown,
        isMaintenance: payload.isMaintenance ?? payload.is_maintenance,
        is_maintenance: payload.is_maintenance,
        countdownPhase: payload.countdownPhase ?? payload.countdown_phase,
        countdown_phase: payload.countdown_phase,
    });
}
